module.exports = __webpack_public_path__ + "img/no_fig.b04e81df.jpg";